import { render } from "./CoBrandBlueprint.vue?vue&type=template&id=fea9c62c&scoped=true"
import script from "./CoBrandBlueprint.vue?vue&type=script&lang=js"
export * from "./CoBrandBlueprint.vue?vue&type=script&lang=js"

import "./CoBrandBlueprint.vue?vue&type=style&index=0&id=fea9c62c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fea9c62c"]])

export default __exports__